export default class BaseBubbleController {
  constructor(controllerId, role) {
    this.controllerId = controllerId;
    this.role = role;
  }

  createBubble(props = {}) {
    const bubble = {
      ...props,
      role: props.role || this.role,
      controllerId: this.controllerId,
      getContent: (bubbleData) => this.getContent(bubbleData),
      update: (existingBubble, updates = {}) =>
        this.updateBubble(existingBubble, updates),
      onBubbleAction: (actionId, payload, context) =>
        this.handleAction(actionId, payload, context),
      onBubbleInit:
        typeof this.onBubbleInit === "function"
          ? (state, uiApi) => this.onBubbleInit(state, uiApi)
          : undefined,
      onBubbleUpdated:
        typeof this.onBubbleUpdated === "function"
          ? (state, uiApi) => this.onBubbleUpdated(state, uiApi)
          : undefined,
      onBubbleCompleted:
        typeof this.onBubbleCompleted === "function"
          ? (state, uiApi) => this.onBubbleCompleted(state, uiApi)
          : undefined,
      onBubbleRendered:
        typeof this.onBubbleRendered === "function"
          ? (state, uiApi) => this.onBubbleRendered(state, uiApi)
          : undefined,
      onBubbleRemoved:
        typeof this.onBubbleRemoved === "function"
          ? (state, uiApi) => this.onBubbleRemoved(state, uiApi)
          : undefined,
    };

    return {
      ...bubble,
      html: this.renderBubbleHtml(bubble),
    };
  }

  updateBubble(existingBubble, updates = {}) {
    const nextBubble = {
      ...existingBubble,
      ...updates,
      role: updates.role || existingBubble.role || this.role,
      controllerId: existingBubble.controllerId || this.controllerId,
      getContent: existingBubble.getContent,
      update: existingBubble.update,
      onBubbleAction: existingBubble.onBubbleAction,
    };

    if (!Object.prototype.hasOwnProperty.call(updates, "html")) {
      nextBubble.html = this.renderBubbleHtml(nextBubble);
    }

    return nextBubble;
  }

  renderBubbleHtml() {
    return "";
  }

  getContent(bubble) {
    return bubble?.content ?? "";
  }

  handleAction() {}
}
